import Link from 'next/link'
import React from 'react'
import { useAppSelector } from 'src/store/hooks'
import { receiptSelector } from 'src/store/joinevent/selectors'
import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'

export const OrderConfirmModal = ({ open = false, closeModal }) => {
    const receipt = useAppSelector(receiptSelector)

    //conditionally render order confirmation messages based on what is in the receipt
    const handleMessage: () => string[] = () => {
        const challenge =
            receipt?.bundle.challenges.find(
                (challenge) => !challenge.isSwag && !challenge.isExercise
            ) ?? null

        const hasAddOn =
            challenge?.items.find((item) => !item.challengeAddonType.isReward) ?? null

        const swag =
            receipt?.bundle.challenges.find((challenge) => challenge.isSwag) ?? null

        const messages: string[] = []
        if (challenge) {
            messages.push(
                'You have successfully joined the event and can start it from your Dashboard!'
            )
        }
        if (challenge?.items.length > 0) {
            messages.push(
                'The rewards you selected for the event will be delivered upon its completion.'
            )
        }
        if (swag || hasAddOn) {
            messages.push(
                'We have started processing your merchandise order.',
                'You will be notified when your items have shipped.'
            )
        }
        return messages
    }

    return (
        <Transition appear show={open} as={Fragment}>
            <Dialog
                as="div"
                className="fixed inset-0 z-50 overflow-y-auto"
                onClose={closeModal}
            >
                <div className="min-h-screen px-4 text-center">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 bg-gray-900 opacity-50" />
                    </Transition.Child>
                    {/* This element is to trick the browser into centering the modal contents. */}
                    <span
                        className="inline-block h-screen align-middle"
                        aria-hidden="true"
                    >
                        &#8203;
                    </span>

                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                    >
                        <div className="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                            <Dialog.Title
                                as="h3"
                                className="text-xl text-center font-medium leading-6 text-yf-green"
                            >
                                Thank you! Your order has been confirmed.
                            </Dialog.Title>
                            <div className="my-4 text-medium rounded-md text-white bg-yf-purple-700">
                                <ul className="ml-4 list-disc">
                                    {handleMessage()?.map((message, idx) => (
                                        <li key={idx}>
                                            <p className="font-base  text-xl my-2">
                                                {message}
                                            </p>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <Link href="/dashboard-new">
                                <button className="px-5 py-2 bg-yf-green rounded-md w-full">
                                    <p className="text-base font-medium text-white">
                                        Take me to my Dashboard
                                    </p>
                                </button>
                            </Link>
                        </div>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition>
    )
}
